// 多组件库的国际化和本地项目国际化兼容
import commonLocale from "@charmdeer/common/lib/locale";
import { storageLocal } from "@pureadmin/utils";
import dayjs from "dayjs";
import updateDayjsLocale from "dayjs/plugin/updateLocale";
// element-plus国际化
import enLocale from "element-plus/dist/locale/en.mjs";
import zhLocale from "element-plus/dist/locale/zh-cn.mjs";
import { createI18n } from "vue-i18n";

import { responsiveStorageNameSpace } from "@/utils/config";

dayjs.extend(updateDayjsLocale);

function siphonI18n(prefix = "zh-CN") {
  const result = {};
  Object.entries(
    import.meta.glob("../../locales/**/*.js", { eager: true })
  ).map(([key, value]) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)[1];
    result[matched] = { ...result[matched], ...value.default };
  });
  return result[prefix];
}

export const localesConfigs = {
  zh: {
    ...siphonI18n("zh-CN"),
    ...zhLocale
  },
  en: {
    ...siphonI18n("en"),
    ...enLocale
  }
};

export const i18n = createI18n({
  legacy: false,
  locale:
    storageLocal().getItem(`${responsiveStorageNameSpace}-locale`)?.locale ??
    "zh",
  fallbackLocale: "en",
  messages: localesConfigs
});

export const $t = (key, options) => {
  const t = i18n.global.t;
  const text = t(key, { ...(options || {}) });
  return text.replace(
    /\{(\w+)\}/g,
    (_, key) => `${options?.[key] ?? `{${key}}`}`
  );
};

export const $tm = (key, defaultString) => {
  const { te, tm } = i18n.global;
  if (!defaultString) {
    return tm(key);
  }
  return te(key) ? tm(key) : defaultString;
};

export const getLocale = () => i18n.global.locale.value;

export function updateBodyLanguageClass(locale) {
  const body = document.body;
  body.className = body.className.replace(/\blang-\S+/g, '');
  body.classList.add(`lang-${locale}`);
}


/**
 * 更新国际化配置
 * @param {String} locale 语言
 * @param {Object} localeMessages 国际化内容
 */
export const updateMessages = (locale, localeMessages = {}) => {
  Object.keys(localeMessages).forEach(key => {
    let message = localeMessages[key];
    if (i18n.global.availableLocales.includes(key)) {
      const m = i18n.global.getLocaleMessage(key);
      message = { ...m, ...message };
    }
    i18n.global.setLocaleMessage(key, message);
  });
  updateLocale(locale);
};

const dayjsLocaleMap = {
  en: "en",
  zh: "zh-cn",
  zh_TW: "zh-tw",
  jp: "ja"
};

const updateDayjs = locale => {
  const _locale = dayjsLocaleMap[locale] || "en";
  dayjs.locale(_locale);
  dayjs.updateLocale(_locale, {
    weekStart: 0
  });
};

const updateCommonLanguage = locale => {
  commonLocale.set(locale);
};

/**
 * 更新国际化配置
 * @param {String} locale 语言
 */
export const updateLocale = locale => {
  return new Promise(resolve => {
    if (locale) {
      setTimeout(() => {
        i18n.global.locale.value = locale;
        resolve();
      }, 100);
      updateBodyLanguageClass(locale)
      updateDayjs(locale);
      updateCommonLanguage(locale);
    }
  });
};
// i18n locale 与后端字段匹配
const i18nLocalMaps = {
  zh: "zh_CN"
};
/**
 * 获取i18n内容
 * @param i18nData
 */
export const getI18nText = i18nData => {
  if (!i18nData) {
    return "";
  }
  let locale = i18n.global.locale.value;
  locale = i18nLocalMaps[locale] || locale;
  return i18nData[locale] || "";
};

/** http 请求 */
export const i18nHttpMaps = {
  zh: "zh-CN"
};

/** channel 语言配置 */
export const channelI18nMaps = {
  zh_TW: "zh-TW"
};

export function useI18n(app) {
  app.use(i18n);
}
